module.exports = __webpack_public_path__ + "img/kjyzyjsfx.695ab6a8.png";